import React from "react";
import PropTypes from "prop-types";
import { Button } from '@/components/ui/button'
import { cn } from "@/lib/utils";

/**
 * CookiesComponent - Converted to shadcn/Tailwind
 * @param {*} props
 */
function CookiesComponent({ 
  open, 
  handleClose, 
  openStatus = false, 
  message = "", 
  actionMessage = "", 
  href, 
  children, 
  className = "", 
  onActionClick = () => {}, 
  onNotificationClose = () => {},
  classes = {},
  ...rest 
}) {

    if (!openStatus) return null;

    return (
        <div className={cn(
            "fixed bottom-0 left-0 right-0 z-50 w-full",
            "bg-gradient-to-r from-primary to-primary-foreground",
            "h-[65px] flex items-center justify-between px-4",
            "text-white dark:text-white",
            "cookiesNotification",
            className
        )}>
            <div className="flex-1 flex items-center">
                <span className="text-sm">{message}</span>
            </div>
            <div className="flex items-center gap-2">
                <Button 
                    className="enableNotification" 
                    color="secondary" 
                    size="small" 
                    variant="outlined" 
                    onClick={onActionClick}
                >
                    {actionMessage}
                </Button>
            </div>
        </div>
    );
}

// prop types
CookiesComponent.propTypes = {
    children: PropTypes.any,
    openStatus: PropTypes.bool,
    onActionClick: PropTypes.func,
    onNotificationClose: PropTypes.func,
    classes: PropTypes.object,
    className: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    actionMessage: PropTypes.string,
};

/** Export Component */
export default CookiesComponent;
